import { Interface, Page } from "@zapier/canvas-state";
import { Icon } from "@zapier/design-system";
import ListItems from "../ListItems";
import { OpenAssetButton } from "../OpenAssetButton";
import styles from "../StepDetails.module.css";
import { publishedProjectUrl } from "../../../utils/getPublishedInterfaceUrl";

interface ProjectDetailsProps {
  project: Interface;
  pages: Page[] | null;
}

export function ProjectDetails({ project, pages }: ProjectDetailsProps) {
  return (
    <div className={styles.wrapper}>
      {pages && (
        <div className={styles.section}>
          <div className={styles.sectionLabel}>
            Pages
            <div className={styles.count}>{pages?.length}</div>
          </div>
          <ListItems
            items={pages?.map((page) => ({
              icon: <Icon name="fileGuide" size={14} />,
              text: page.name,
              link: `${publishedProjectUrl(project, page)}`,
            }))}
          />
        </div>
      )}
      <OpenAssetButton
        href={`${publishedProjectUrl(project)}`}
        eventAsset="Interface Project"
        assetNoun="page"
      />
    </div>
  );
}
